import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { EndocrineProgesteroneDiagramContent } from "./EndocrineProgesteroneDiagram";
import { EndocrineProgesteroneKeyContent } from "./EndocrineProgesteroneKey";

const SvgEndocrineProgesteroneDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1000, 1278)}
      viewBox={diagramOnly ? "0 204 1024 1000" : "0 0 1024 1278"}
    >
      <g id="endocrine-progesterone-diagram+key" clipPath="url(#clip0_18293_224306)">
        <rect width={1024} height={diagramOnly ? 1000 : 1278} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <EndocrineProgesteroneKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <EndocrineProgesteroneDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_224306">
          <rect width={1024} height={1278} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_224306">
          <rect width={1024} height={1000} fill="white" transform="translate(0 204)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEndocrineProgesteroneDiagramKey;
